<script>
    import { createEventDispatcher, onMount, onDestroy, afterUpdate, beforeUpdate} from 'svelte';
    import { __ } from '../utils/i18n';


    import Bindery from 'bindery';


    const dispatch = createEventDispatcher();
    function closePrint() { dispatch('printDrawer') }

    function escapePrint(e) {
        if (e.key == 'Escape') {
          closePrint()
        }
    }

    var isFirefox = typeof InstallTrigger !== 'undefined';
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);


    onMount(() => {
      // const { createRule } = window.bindery;
      // var tab = window.open('about:blank', '_blank');
      // tab.document.write(html);

      // state map placement
      const root = document.querySelector('.📖-root')
      // console.log(root)

      if (root == null) {
        let stateMap = document.querySelector(
        '#assembly-senate div.mapboxgl-canvas-container canvas.mapboxgl-canvas'
        );
        let mapContent = stateMap.toDataURL('image/png', 1.0);
        document.getElementById('stateMap').src = mapContent

        let pdfcontent = document.getElementById('pdf');
        let sections = document.querySelectorAll('.print');

        let pdfheader = pdfcontent.querySelector('header');
        let logo = document.querySelector('.flag-label');
        let logoclone = logo.cloneNode(true);
        logoclone.hidden = false;

        pdfheader.appendChild(logoclone);
        sections.forEach((section) => {
          let clone = section.cloneNode(true);
          clone.hidden = false;
          pdfcontent.appendChild(clone);
        });

        let breakrule = Bindery.PageBreak({
          selector: 'section',
          position: 'avoid',
        });

        let footerrule = Bindery.createRule({
          render: (pg , date) =>
            `<a href="www.latimes.com/shapeyourla">www.latimes.com/shapeyourla</a>
            <span>${date}</span>`,
          eachPage: function (pg) {
            let date = new Date(); 
            if (!pg.myCustomProp) {
              // if myCustomProp isn't set, the page is rendering for the first time, so set up the footer. you can name this whatever you want.
              const elmt = document.createElement('div');
              elmt.classList.add('custom-footer');

              pg.element.appendChild(elmt);
              pg.myCustomProp = elmt;
            }
            // the innerHTML of the footer is updated multiple times during rendering, as we figure out the final page number.
            pg.myCustomProp.innerHTML = this.render(pg, date.toLocaleDateString());
          },
        });
      
        Bindery.makeBook({
          content: pdfcontent,
          pageSetup: {
            size: { width: '9in', height: '12in' },
          },
          printSetup: {
            layout: Bindery.Layout.PAGES,
            paper: Bindery.Paper.AUTO,
          },
          view: Bindery.View.PRINT,
          rules: [
            breakrule,
            footerrule
          ],
        });

        let zoomScaler = document.querySelector(".📖-zoom-scaler")
        const availableSize = {
          width: window.outerWidth,
          height: window.innerHeight - 40, // toolbar
        };

        let ratio = availableSize.width / 864;

        if (ratio<1){
          zoomScaler.style.transform = `scale(${ratio})`
        }
      } else {
        // console.log("no new book")
        root.removeAttribute('style')
        const body = document.querySelector('body');
        body?.classList.add( '📖-viewing')
      }
    })

    onDestroy(() => {
      const body = document.querySelector('body');
      body?.removeAttribute('class')

      const root = document.querySelector('.📖-root')
      root.style.display ='none'
    })

    afterUpdate(() => {
      let printButton = document.querySelector(".📖-btn-print");
      printButton?.setAttribute("aria-label", __('Print pdf of representatives'));
    })
</script>

<svelte:window on:keydown={escapePrint} />

{#if isFirefox && isAndroid }  
  <div class="ffandroid-notice">
    For Firefox on Android, please use your browser to 
    <a href="https://support.mozilla.org/en-US/kb/save-web-pages-pdf-firefox-android" target="_blank">Save webpage as PDF.</a>
  </div>
{/if}
<div id="close_print" class="close" tabindex="0" aria-label="{__('Close print module')}" role="button" 
  on:click={closePrint} 
  on:keypress={(e)=>{if (e.key === "Enter") closePrint()}}
  >    
  Cancel
</div>


<!-- DON'T USE SLIDE TRANSITION: BREAKS PDF and PRINT ON SAFARI-->

<section id="pdf">
  <header>
    <h1>
      Shape Your L.A.
    </h1>
  </header>
</section>